import { render, staticRenderFns } from "./AppCustomShortcutsDisplay.vue?vue&type=template&id=45c40752"
import script from "./AppCustomShortcutsDisplay.vue?vue&type=script&lang=js"
export * from "./AppCustomShortcutsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports